var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 211,
    viewBox: "0 0 211 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.343 16.8829C150.744 22.1223 169.594 34.7781 182.546 52.6019C195.497 70.4257 201.711 92.2636 200.084 114.236L154.38 110.851C155.207 99.6893 152.05 88.5959 145.471 79.5417C138.892 70.4874 129.316 64.0584 118.445 61.3969L129.343 16.8829Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.078 114.314C198.382 136.955 188.475 158.197 172.218 174.048L140.225 141.235C148.483 133.183 153.516 122.392 154.377 110.89L200.078 114.314Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.207 174.058C156.938 188.941 137.024 198.135 115.792 200.103L111.561 154.471C122.347 153.471 132.463 148.8 140.219 141.24L172.207 174.058Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.902 200.093C93.531 202.194 71.1548 196.137 52.8977 183.04C34.6406 169.942 21.7333 150.687 16.5551 128.822L61.1501 118.261C63.7806 129.367 70.3373 139.149 79.6117 145.803C88.886 152.456 100.253 155.533 111.617 154.465L115.902 200.093Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2533 31.4159C42.0413 20.6279 55.0507 12.3204 69.376 7.07158C83.7013 1.8228 98.9983 -0.24114 114.202 1.0234L105.5 105.662L31.2533 31.4159Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.805024 113.666C-0.357965 98.4539 1.80807 83.171 7.15238 68.8811C12.4967 54.5912 20.8909 41.6376 31.7507 30.9218L105.5 105.662L0.805024 113.666Z",
    fill: "#E5E5E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/empty-chart.03f7b21748541042a43a835a4ca748ce.svg";
export { ForwardRef as ReactComponent };